import React from 'react';

import type {
  LayoutType,
  PlacementId,
  RecommendationCategories
} from '@schibsted-nmp/advertising-shared';

import type { AdSlot, ContainerId } from '../index.js';

/**
 * This component is used to render an advertising web component, only on the
 * client-side to help with hydration issues.
 */
export function AdvertisingClientWebComponent(
  props: AdvertisingClientWebComponent.Props
) {
  return <AdvertisingClientWebComponent.Forwarded {...props} />;
}

export namespace AdvertisingClientWebComponent {
  export type Props = React.ComponentProps<typeof Forwarded>;

  export const Forwarded = React.forwardRef<HTMLDivElement, Forwarded.Props>(
    (
      { placementId, adIndex, initialLayoutType, categories, containerId },
      ref
    ) => {
      const [clientSide, setClientSide] = React.useState(false);

      React.useEffect(() => {
        setClientSide(true);
      }, []);

      if (!clientSide) return null;

      return (
        <advt-component
          containerId={containerId}
          initialLayoutType={initialLayoutType}
          categories={categories}
          adIndex={adIndex}
          placementId={placementId}
        >
          <div
            ref={ref}
            id={`${placementId}--container` satisfies ContainerId}
            slot={`${placementId}--slot` satisfies AdSlot}
          ></div>
        </advt-component>
      );
    }
  );

  export namespace Forwarded {
    export type Props = {
      placementId: PlacementId;
      containerId?: string | undefined;
      adIndex?: number | undefined;

      /** The categories of the item to get the `placementId` for. */
      categories?: RecommendationCategories | undefined;

      /** The initial layout type of the item to get the `placementId` for. (Grid or List) */
      initialLayoutType?: LayoutType | undefined;
    };
  }
}
